import { gql } from '@apollo/client';

export const UPDATE_MULTI_UTILITY_ACCOUNT = gql`
  mutation Flex_UpdateMultiUtilityAccount(
    $planId: Int!
    $input: MultiUtilityAccountEnrollmentInput!
  ) {
    multiUtilityAccountEnrollment(planId: $planId, input: $input) {
      id
    }
  }
`;
